module.exports = __webpack_public_path__ + "static/media/destroyed_fortification_120.366c8a70.png";